var app = angular.module("leonardo");

var TemplatesStates = function($stateProvider) {
  $stateProvider.state('templates', {
    url: '/templates',
    parent: 'authenticated.layout-main',
    views: {
      'user': {
        templateUrl: 'views/templates/user/logged.html',
        controller: 'UserMenu'
      }
    },
    redirectTo: function (PermissionService) {
      if (PermissionService.permissionAvailableAccount('permission_view_templates', true)) {
        return 'templates.list';
      }
      else if (PermissionService.permissionAvailableAccount('permission_view_templates_calendar', true) &&
        PermissionService.authDataService.isNotStaff()) {
        return 'templates.calendar';
      }
      else if (PermissionService.permissionAvailableAccount('permission_view_trigger_templates', true)) {
        return 'templates.trigger';
      }
      else {
        return 'home';
      }
    },
    ncyBreadcrumb: {
      label: 'Templates'
    }
  });

  $stateProvider.state('templates.audit', {
    url: "/audit",
    title: 'Template Audit',
    cssClass: 'page-template-list',
    templateMode: 'audit',
    views: {
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'TemplateAuditFilters'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/template-audit.html',
        controller: 'TemplateListActions'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/template/audit.html',
        controller: 'TemplateAudit'
      }
    },
    ncyBreadcrumb: {
      label: 'Template Audit'
    }
  });

  $stateProvider.state('templates.trigger', {
    url: "/trigger",
    title: 'Trigger templates',
    cssClass: 'page-template-list',
    templateMode: 'trigger',
    views: {
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'TemplateTriggerFilters'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/template-trigger.html',
        controller: 'TemplateListActions'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/template/triggers.html',
        controller: 'TemplateTriggerList'
      }
    },
    ncyBreadcrumb: {
      label: 'Trigger templates'
    }
  });

  $stateProvider.state('templates.calendar', {
    url: "/calendar",
    title: 'Calendar',
    cssClass: 'page-template-list',
    templateMode: 'template',
    views: {
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'TemplateCalendarFilters'
      },
      'content@authenticated.layout-main': { templateUrl: 'views/templates/template/calendar.html' }
    },
    ncyBreadcrumb: {
      label: 'Calendar'
    }
  });

  $stateProvider.state('templates.list', {
    url: "/templates",
    cssClass: 'page-template-list',
    templateMode: 'template',
    title: 'Action Items',
    views: {
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'TemplateListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/template/list.html',
        controller: 'TemplateList'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/template-list.html',
        controller: 'TemplateListActions'
      }
    },
    ncyBreadcrumb: {
      label: 'Action Items'
    }
  });

  $stateProvider.state('templates.list.descendants', {
    url: "/:id",
    cssClass: 'page-template-list',
    templateMode: 'template',
    title: 'Action Items',
    no_icon_descendants: true,
    views: {
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'TemplateListFilters'
      },
      'title@authenticated.layout-main': {
        templateUrl: 'views/templates/template/title.html'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/template/list.html',
        controller: 'TemplateList'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/template-list.html',
        controller: 'TemplateListActions'
      }
    },
    ncyBreadcrumb: {
      label: 'Action Items'
    }
  });

  $stateProvider.state('templates.list.root_group', {
    url: "/root_group/:id",
    cssClass: 'page-template-list',
    templateMode: 'template',
    title: 'Action Items',
    no_icon_descendants: true,
    template_group: true,
    views: {
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'TemplateListFilters'
      },
      'title@authenticated.layout-main': {
        templateUrl: 'views/templates/template/title.html'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/template/list.html',
        controller: 'TemplateList'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/template-list.html',
        controller: 'TemplateListActions'
      }
    },
    ncyBreadcrumb: {
      label: 'Action Items'
    }
  });





  $stateProvider.state('templates.edit', {
    url: "/:pk/edit",
    title: 'Template edit',
    params: {
      pk: '',
      squash: false
    },
    cssClass: 'page-template-edit',
    templateMode: 'template',
    action: 'edit',
    views: {
      'filters@authenticated.layout-main': {},
      'content@authenticated.layout-main': {
        controller: 'TemplateForm',
        templateUrl: 'views/templates/template/form.html'
      }
    },
    resolve: {
      templateObj: ['TemplateService', '$stateParams', function(TemplateService, $stateParams) {
        return TemplateService.get($stateParams.pk);
      }]
    },
    ncyBreadcrumb: {
      label: 'Template edit'
    }
  });

  $stateProvider.state('templates.add', {
    url: "/add?account&portfolios&properties",
    title: 'Add Template',
    cssClass: 'page-template-edit',
    templateMode: 'template',
    action: 'create',
    views: {
      'filters@authenticated.layout-main': {},
      'actions@authenticated.layout-main': {},
      'content@authenticated.layout-main': {
        controller: 'TemplateForm',
        templateUrl: 'views/templates/template/form.html'
      }
    },
    resolve: {
      templateObj: ['TemplateService', '$stateParams', function(TemplateService, $stateParams) {
        return TemplateService.bulkObject($stateParams.account);
      }]
    },
    ncyBreadcrumb: {
      label: 'Template add'
    }
  });

  $stateProvider.state('templates.add-trigger', {
    url: "/add-trigger?account",
    title: 'Add Template',
    cssClass: 'page-template-edit',
    templateMode: 'trigger',
    action: 'create',
    views: {
      'filters@authenticated.layout-main': {},
      'actions@authenticated.layout-main': {},
      'content@authenticated.layout-main': {
        controller: 'TemplateForm',
        templateUrl: 'views/templates/template/form-trigger.html'
      }
    },
    resolve: {
      templateObj: ['TemplateTriggerService', '$stateParams', function(TemplateTriggerService, $stateParams) {
        return TemplateTriggerService.bulkObject($stateParams.account);
      }]
    },
    ncyBreadcrumb: {
      label: 'Template add'
    }
  });
};

app.config(['$stateProvider', TemplatesStates]);
